<template>
  <CSidebar class="bg-clr" fixed :minimize="minimize" :show.sync="show">
    <CSidebarHeader class="bg-clr" :withSubheader="subheader">
      <div class="col-12 logo">
        <div>
          <a
            :href="getOrgWebsite || 'javascript:void(0)'"
            :target="getOrgWebsite ? '_blank' : '_self'"
          >
            <img
              class="mw-100 h-auto"
              :src="getHeaderLogo"
              @error="$event.target.src = '/img/new_tf_logo.svg'"
            />
          </a>
        </div>
      </div>
    </CSidebarHeader>
    <CRenderFunction flat :content-to-render="headerMenus" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="minimize = !minimize"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import { mapGetters } from "vuex";
import { Role, TFW_CANDIDATE_URL } from "@/helpers/helper";
export default {
  name: "TheSidebar",
  data() {
    return {
      minimize: false,
      subheader: true,
      nav,
      show: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters([
      "getRoleScopes",
      "isDbSwitchAvailable",
      "getCandidateListUrlBasedOnRole",
      "getIsParentUser",
      "getImages",
      "getOrgDetail",
      "getUserAcl",
      "isSuperCustomer",
      "isEducationalInstitute",
      "getUser",
      "isCustomerAdmin",
      "getOrgTypeIDFromAccessToken",
      "isPartnerFromAccessToken",
      "getUserAclv2",
      "getUserAclv2Menu",
      "isCustomerAdmin",
      "isCustomerRecruiter",
    ]),
    getHeaderLogo() {
      return this.getImages?.header_logo;
    },
    getOrgWebsite() {
      return this.getOrgDetail?.website || "";
    },
    dashboardNav() {
      let role = this.getRoleScopes[0];

      if (Role.systemAdmin === role) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Dashboard"],
          },
          {
            _name: "CSidebarNavItem",
            name: "System Dashboard",
            to: "/dashboard",
            icon: "cil-library",
          },
        ];
      } else if ([Role.customerAdmin, Role.customerRecruiter].includes(role)) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Dashboard"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Recruiter Dashboard",
            to: "/recruiter-dashboard",
            icon: "cil-library",
          },
        ];
      }

      return [];
    },
    candidateNav() {
      let role = this.getRoleScopes[0];
      if (role === Role.customerAdmin || role === Role.customerRecruiter) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Candidates"],
          },
          {
            _name: "CSidebarNavItem",
            name: "List Candidates",
            to: this.getCandidateListUrlBasedOnRole,
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Job Candidates Status",
            to: "/job-candidates-status?tab=allTab",
            icon: "cil-library",
          },
        ];
      } else if (role === Role.systemAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Candidates"],
          },
          {
            _name: "CSidebarNavItem",
            name: "List Candidates",
            to: this.getCandidateListUrlBasedOnRole,
            icon: "cil-library",
          },
        ];
      }
      return [];
    },
    hospitalNav() {
      let role = this.getRoleScopes[0];
      // hot fix in production
      // if customerAdmin or customerRecruiter for now we're removing hospital menu
      if (role === Role.customerAdmin || role === Role.customerRecruiter) {
        return [];
      }
      if (role === Role.customerAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Hospitals"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Hospital Recruiters",
            to: "/add-hospital-recruiters",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Registered Hospital Recruiters",
            to: "/hospital-recruiters-list",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Registered Hospital Recruiters",
            to: "/hospital-recruiters-list",
            icon: "cil-library",
          },
        ];
      } else if (role === Role.systemAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Hospitals"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Hospital",
            to: "/add-hospital",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Hospital Administrator",
            to: "/add-hospital-admin",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Registered Hospitals",
            to: "/hospital-list",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Registered Hospital Administrators",
            to: "/hospital-admin-list",
            icon: "cil-library",
          },
        ];
      }

      return [];
    },
    jobsNav() {
      let role = this.getRoleScopes[0];

      if (role === Role.systemAdmin || role === Role.systemRecruiter) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Jobs"],
          },
          {
            _name: "CSidebarNavItem",
            name: "List Jobs",
            to: "/job-list",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavTitle",
            _children: ["Job Board"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Active Jobs",
            to: "/jobs-list/status/active",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Inactive Jobs",
            to: "/jobs-list/status/inactive",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Archive Jobs",
            to: "/jobs-list/status/archive",
            icon: "cil-library",
          },
        ];
      } else if (
        role === Role.customerAdmin ||
        role === Role.customerRecruiter
      ) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Jobs"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Job",
            to: "/add-job?step=0",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "List Jobs",
            to: "/job-list",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavTitle",
            _children: ["Job Board"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Active Jobs",
            to: "/jobs-list/status/active",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Inactive Jobs",
            to: "/jobs-list/status/inactive",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Archive Jobs",
            to: "/jobs-list/status/archive",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Job Templates",
            to: "/list-job-templates",
            icon: "cil-library",
          },
        ];
      }
      /*
      <!-- Hiding this, Job Board to be launched later - by venki -->
        else if (role === Role.systemCandidate || role === Role.customerCandidate) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Jobs"]
          },
          {
            _name: "CSidebarNavItem",
            name: "Job board",
            to: "/public/job-board",
            icon: "cil-library"
          }
        ];
      } */
      return [];
    },
    jobTemplatesNav() {
      let role = this.getRoleScopes[0];

      if (role === Role.customerAdmin || role === Role.customerRecruiter) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Job Templates"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Job Templates",
            to: "/list-job-templates",
            icon: "cil-library",
          },
        ];
      }
      return [];
    },
    facilityNav() {
      let role = this.getRoleScopes[0];
      // hot fix in production
      // if customerAdmin or customerRecruiter for now we're removing facility menu
      if (role === Role.systemAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Facilities"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Facility",
            to: "/add-facility",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Reports",
            to: "/facility-list",
            icon: "cil-library",
          },
        ];
      } else if (role === Role.customerAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Facilities"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Facility Details",
            to: "/facility-detail",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Facility Admin / User",
            to: "/add-facilityuser",
            icon: "cil-library",
          },
        ];
      }

      return [];
    },
    customerNav() {
      let role = this.getRoleScopes[0];
      if (role === Role.systemAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Customers"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Customer",
            to: "/add-customer",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "Customer List",
            to: "/customer-list",
            icon: "cil-library",
          },
          // Only for the system admins the admin DB switch lets in (modules/dbSwitch.js).
          ...(this.isDbSwitchAvailable
            ? [
                {
                  _name: "CSidebarNavItem",
                  name: "Database Switch",
                  to: "/db-switch",
                  icon: "cil-library",
                },
              ]
            : []),
        ];
      }

      return [];
    },
    organisationNav() {
      if (this.getIsParentUser === true) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Organisation"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add Organisation",
            to: "/add-organisation",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "List Organisation",
            to: "/organisation-list",
            icon: "cil-library",
          },
        ];
      }
      return [];
    },
    contactUserNav() {
      let role = this.getRoleScopes[0];
      if (role === Role.customerAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Users"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Add User",
            to: "/add-contactuser",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "List User",
            to: "/list-contactuser",
            icon: "cil-library",
          },
        ];
      }
      return [];
    },
    settings() {
      let role = this.getRoleScopes[0];
      if (role === Role.customerAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Setting"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Config Fields",
            to: "/configurable-fields",
            icon: "cil-library",
          },
        ];
      }
      return [];
    },
    config() {
      let role = this.getRoleScopes[0];
      if (role === Role.customerAdmin) {
        return [
          {
            _name: "CSidebarNavTitle",
            _children: ["Config"],
          },
          {
            _name: "CSidebarNavItem",
            name: "Public Job Board",
            to: "/config-public-job-board",
            icon: "cil-library",
          },
          {
            _name: "CSidebarNavItem",
            name: "OnBoard Docs",
            to: "/onboarding-documents",
            icon: "cil-library",
          },
        ];
      }

      return [];
    },
    sideBarNav() {
      let role = this.getRoleScopes[0];
      if (role === Role.systemCandidate || role === Role.customerCandidate) {
        return [
          {
            _name: "CSidebarNav",
            _children: [...this.jobsNav],
          },
        ];
      } else {
        const v3 = this.getAclV3;
        if (this.getUserAcl?.length) {
          const organisationTypes = {
            hospital: 1,
            agency: 3,
            educational_institute: 18,
          };
          const isCustomerAdmin = this.isCustomerAdmin;
          const isCustomerRecruiterUser = this.isCustomerRecruiter;
          if (
            Object.values(organisationTypes).includes(
              this.getOrgTypeIDFromAccessToken,
            ) &&
            (isCustomerAdmin || isCustomerRecruiterUser)
          ) {
            return this.getAclV3;
          }
          let returnData = [];
          for (const menu of this.getUserAcl) {
            if (menu.menu != "Candidates") {
              returnData = [
                ...returnData,
                {
                  _name: "CSidebarNavTitle",
                  _children: [menu.menu],
                },
              ];
            }
            // MENU ITEMS
            let menuItems = [...menu.menu_items];
            if (
              menuItems.includes("Profile Page") &&
              this.getRoleScopes[0] !== Role.customerAdmin
            ) {
              menuItems = menuItems.filter((i) => i !== "Profile Page");
            }

            for (const item of menuItems) {
              let encodedItem = item.toLowerCase().replaceAll(" ", "_");
              if (
                [
                  "view/edit_job_board",
                  "organisation",
                  "users",
                  "config",
                  "job_templates",
                ].includes(encodedItem) ||
                (menu.menu === "Candidates" && encodedItem === "talent_pool")
              ) {
                returnData = [
                  ...returnData,
                  ...this.getItemWithSubMenu(encodedItem),
                ];
              } else {
                if (menu.menu === "Candidates") {
                  returnData = [
                    ...returnData,
                    {
                      _name: "CSidebarNavTitle",
                      _children: [menu.menu],
                    },
                  ];
                }
                if (encodedItem === "update_thumbnail") {
                  returnData = [
                    ...returnData,
                    {
                      _name: "CSidebarNavItem",
                      name: item,
                      icon: "cil-library",
                      to: "/update-thumbnail",
                    },
                  ];
                } else {
                  returnData = [
                    ...returnData,
                    {
                      _name: "CSidebarNavItem",
                      name: item,
                      to: this.getPathForMenu(encodedItem),
                      icon: "cil-library",
                    },
                  ];
                }
              }
            }
          }
          return [
            {
              _name: "CSidebarNav",
              _children: [...returnData],
            },
          ];
        } else {
          return [
            {
              _name: "CSidebarNav",
              _children: [
                ...this.dashboardNav,
                ...this.candidateNav,
                ...this.customerNav,
                // ...this.hospitalNav
                //Temporarily Removed for R1 release
                //...this.facilityNav,
                ...this.jobsNav,
                ...this.organisationNav,
                ...this.contactUserNav,
                // ...this.jobTemplatesNav,
                // ...this.settings,
                //Temporarily Removed for R1 release
                ...this.config,
              ],
            },
          ];
        }
      }
    },
    getAclV3() {
      const subMenus = {
        candidates: {
          candidates: [
            {
              label: "Full Registered",
              menu: "full_registered_candidates",
            },
            {
              label: "Short Registered",
              menu: "short_registered_candidates",
            },
            {
              label: "All",
              menu: "all_candidates",
            },
          ],
        },
        jobs: {
          view_edit_job_board: [
            {
              label: "Active Jobs",
              menu: "active_jobs",
            },
            {
              label: "Inactive Jobs",
              menu: "inactive_jobs",
            },
            {
              label: "Archive Jobs",
              menu: "archive_jobs",
            },
          ],
        },
        settings: {
          users: [
            {
              label: "Add User",
              menu: "add_user",
            },
            {
              label: "List User",
              menu: "list_user",
            },
          ],
          organisation: [
            {
              label: "Add Organisation",
              menu: "add_organisation",
            },
            {
              label: "List Organisation",
              menu: "list_organisation",
            },
          ],
          config: [
            {
              label: "Theme and Logo",
              menu: "theme_and_logo",
            },
            {
              label: "Document Library",
              menu: "document_library",
            },
            {
              label: "Email Config",
              menu: "email_config",
            },
          ],
        },
      };
      const isEducationalInstitute = this.isEducationalInstitute;
      const aclMenus = this.getUserAclv2Menu.map((item) => {
        const menu_group_name =
          isEducationalInstitute && item.menu_group_name === "Candidates"
            ? "Students"
            : item.menu_group_name;
        return {
          label: menu_group_name,
          menu: this.convertToSnackCase(item.menu_group_name),
          menu_items: item.menus.map((subItem) => ({
            label:
              isEducationalInstitute && menu_group_name === "Students"
                ? "Students"
                : subItem.option_name,
            menu: this.convertToSnackCase(subItem.option_name),
            menu_items:
              menu_group_name === "Students"
                ? []
                : subMenus[this.convertToSnackCase(item.menu_group_name)]?.[
                    this.convertToSnackCase(subItem.option_name)
                  ] || [],
          })),
        };
      });
      const filteredMenus = this.convertToCoreUI(aclMenus);
      return filteredMenus;
    },
    getAclV2() {
      const isCustomerAdmin = this.isCustomerAdmin;
      const isSystemAdmin = this.isSystemAdminFromAccessToken;
      const isPartner = this.isPartnerFromAccessToken;
      const MENU_STRUCTURE = [
        {
          menu: "Dashboard",
          menu_items: [
            {
              menu_item: "Dashboard",
              mapped: "Landing Page",
              icon: "cil-library",
              cond_display: !isSystemAdmin,
            },
            {
              menu_item: "Dashboard",
              mapped: "Dashboard",
              cond_display: isSystemAdmin,
              icon: "cil-library",
            },
            {
              menu_item: "Management Report",
              mapped: "Management Reports",
              disabled: this.isEducationalInstitute,
              icon: "cil-library",
            },
          ],
        },
        {
          menu: "Candidates",
          cond_display: !this.isEducationalInstitute,
          menu_items: [
            {
              menu_item: "Talent Pool",
              mapped: "Talent Pool",
              menu_items: [
                { menu_item: "Full Registered", params: "full_registration" },
                { menu_item: "Short Registered", params: "short_registration" },
                { menu_item: "All" },
              ],
            },
            { menu_item: "Recruitment Status", mapped: "Recruitment" },
          ],
        },
        {
          menu: "Students",
          cond_display: this.isEducationalInstitute,
          mapped: "Talent Pool",
          menu_items: [{ menu_item: "Talent Pool" }],
        },
        {
          menu: "Jobs",
          mapped: "Job Board",
          menu_items: [
            { menu_item: "Job List" },
            { menu_item: "Allocate Job", org_types: [3] },
            { menu_item: "Create Job" },
            {
              menu_item: "View/Edit Job Board",
              menu_items: [
                { menu_item: "Active Jobs" },
                { menu_item: "Inactive Jobs" },
                { menu_item: "Archive Jobs" },
              ],
            },
            { menu_item: "Job Templates" },
            {
              menu_item: "Public Job Board",
              cond_display: isCustomerAdmin,
            },
          ],
        },
        {
          menu: "Campaign",
          menu_items: [{ menu_item: "Campaign Form", mapped: "Campaigns" }],
        },
        {
          menu: "Settings",
          menu_items: [
            {
              menu_item: "Organisation",
              cond_display: (isCustomerAdmin || isSystemAdmin) && !isPartner,
              menu_items: [
                { menu_item: "Organisation Add" },
                { menu_item: "Organisation List" },
              ],
            },
            { menu_item: "Customer Template", cond_display: !isPartner },
            {
              menu_item: "Users",
              mapped: "User Management",
              cond_display: isCustomerAdmin,
              menu_items: [
                { menu_item: "Add User" },
                { menu_item: "List User" },
              ],
            },
            {
              menu_item: "Config",
              cond_display: !isPartner,
              menu_items: [
                { menu_item: "Theme and Logo" },
                {
                  menu_item: "Document library",
                  cond_display: !this.isEducationalInstitute,
                },
                { menu_item: "Email Config" },
              ],
            },
            {
              menu_item: "Profile Page",
              cond_display: isCustomerAdmin && !isPartner,
            },
            { menu_item: "Add Profile Page", cond_display: isPartner },
            { menu_item: "Setup AI Web Page", cond_display: isPartner },
            { menu_item: "Update Thumbnail", cond_display: isPartner },
          ],
        },
        {
          menu: "TalentFind",
          cond_display: this.hasTFMRelationship,
          menu_items: [
            {
              menu_item: "Talent Pool",
              params: "super_customer/full_registration",
            },
          ],
        },
      ];

      const filteredMenus = this.filterMenu(MENU_STRUCTURE);
      return [
        {
          _name: "CSidebarNav",
          _children: filteredMenus.flatMap(this.buildForMenu),
        },
      ];
    },

    isDesktopView() {
      return this.windowWidth > 999;
    },
    headerMenus() {
      const courseAdministratorMenu = [
        {
          _name: "CSidebarNav",
          _children: [
            { _name: "CSidebarNavTitle", _children: ["Students"] },
            {
              _name: "CSidebarNavItem",
              name: "Talent Pool",
              to: "/candidate-list",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Courses"] },
            {
              _name: "CSidebarNavItem",
              name: "Course List",
              to: "/list-course",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Create Course",
              to: "/add-course",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Settings"] },
            {
              _name: "CSidebarNavItem",
              name: "Config",
              to: "/config-public-job-board",
              icon: "cil-library",
            }, // or map to desired route
          ],
        },
      ];

      const tutorMenu = [
        {
          _name: "CSidebarNav",
          _children: [
            { _name: "CSidebarNavTitle", _children: ["Dashboard"] },
            {
              _name: "CSidebarNavItem",
              name: "Dashboard",
              to: "/recruiter-dashboard",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Students"] },
            {
              _name: "CSidebarNavItem",
              name: "Talent Pool",
              to: "/candidate-list",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Courses"] },
            {
              _name: "CSidebarNavItem",
              name: "Course List",
              to: "/list-course",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Create Course",
              to: "/add-course",
              icon: "cil-library",
            },
          ],
        },
      ];

      const supportMenu = [
        {
          _name: "CSidebarNav",
          _children: [
            { _name: "CSidebarNavTitle", _children: ["Dashboard"] },
            {
              _name: "CSidebarNavItem",
              name: "Dashboard",
              to: "/recruiter-dashboard",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Students"] },
            {
              _name: "CSidebarNavItem",
              name: "Talent Pool",
              to: "/candidate-list",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Courses"] },
            {
              _name: "CSidebarNavItem",
              name: "Course List",
              to: "/list-course",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Create Course",
              to: "/add-course",
              icon: "cil-library",
            },

            { _name: "CSidebarNavTitle", _children: ["Settings"] },
            {
              _name: "CSidebarNavItem",
              name: "Customer Template",
              to: "/customer_template",
              icon: "cil-library",
            },
          ],
        },
      ];

      const roleKey = this.normalizeKey(
        this.getUser?.users_roles?.[0]?.display_name || "",
      );
      if (this.isEducationalInstitute) {
        if (roleKey === "course_administrator") return courseAdministratorMenu;
        if (roleKey === "tutor") return tutorMenu;
        if (roleKey === "support") return supportMenu;
      }
      return this.sideBarNav;
    },
    isShortRegistration() {
      const { params } = this.$route;
      return (
        (params?.registration_type || params.customer_type) ===
          "short_registration" || false
      );
    },
    isFullRegistration() {
      const { params } = this.$route;
      return (
        (params?.registration_type || params.customer_type) ===
          "full_registration" || false
      );
    },
    isHasRegistrationType() {
      const { params } = this.$route;
      return ["short_registration", "full_registration"].includes(
        params?.registration_type || params.customer_type,
      );
    },
  },
  methods: {
    convertToCoreUI(menuData) {
      const result = [];

      for (const main of menuData) {
        const items = main.menu_items || [];

        const hasNested = items.some(
          (i) => i.menu_items && i.menu_items.length > 0,
        );
        const hasLeaf = items.some(
          (i) => !i.menu_items || i.menu_items.length === 0,
        );

        const groupedItems = [];
        const separateItems = [];

        for (const item of items) {
          // ✅ Leaf node
          if (!item.menu_items || item.menu_items.length === 0) {
            if (hasNested && hasLeaf) {
              separateItems.push(item);
            } else {
              groupedItems.push(this.makeNavItem(item));
            }
          } else {
            groupedItems.push(...this.getLeafItems(item.menu_items));
          }
        }

        // ✅ Add grouped section
        if (groupedItems.length > 0) {
          result.push({
            _name: "CSidebarNavTitle",
            _children: [main.label],
          });

          result.push(...groupedItems);
        }

        // ✅ Add separated items (Recruitment Status)
        for (const sep of separateItems) {
          result.push({
            _name: "CSidebarNavTitle",
            _children: [sep.label],
          });

          result.push(this.makeNavItem(sep));
        }
      }

      return [
        {
          _name: "CSidebarNav",
          _children: result,
        },
      ];
    },
    getLeafItems(items) {
      let result = [];

      for (const item of items) {
        if (!item.menu_items || item.menu_items.length === 0) {
          result.push(this.makeNavItem(item));
        } else {
          result.push(...this.getLeafItems(item.menu_items));
        }
      }

      return result;
    },
    makeNavItem(item) {
      const encodedItem = item.menu.toLowerCase().replaceAll(" ", "_");
      return {
        _name: "CSidebarNavItem",
        name: item.label,
        to: this.getPathForMenu(encodedItem),
        icon: "cil-circle",
      };
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      this.show = !this.isDesktopView && this.show;
    },
    filterMenu(items) {
      const allowedMenus = this.getUserAclv2.map((a) => a.menu);
      const currentOrgId = this.getOrgTypeIDFromAccessToken;

      const permissionSet = new Set(allowedMenus);
      return items
        .map((menu) => {
          if (menu.cond_display !== undefined && !menu.cond_display) {
            return null;
          }
          if (
            menu.org_types != undefined &&
            !menu.org_types.includes(currentOrgId)
          ) {
            return null;
          }

          if (menu.mapped && !permissionSet.has(menu.mapped)) {
            return null;
          }

          if (menu.menu_items) {
            const children = this.filterMenu(menu.menu_items);
            if (menu.mapped && permissionSet.has(menu.mapped)) {
              return menu;
            }

            if (!children.length) return null;

            return { ...menu, menu_items: children };
          }
          return menu;
        })
        .filter(Boolean);
    },
    buildForMenu(menu) {
      const result = [];

      // Title
      result.push({
        _name: "CSidebarNavTitle",
        _children: [menu.menu],
      });

      const submenuSections = [];

      (menu.menu_items || []).forEach((item) => {
        // If submenu exists
        if (item.menu_items && item.menu_items.length) {
          const section = [];

          section.push({
            _name: "CSidebarNavTitle",
            _children: [item.menu_item],
          });

          item.menu_items.forEach((sub) => {
            section.push(this.buildNavItem(sub));
          });

          submenuSections.push(...section);
        } else {
          result.push(this.buildNavItem(item));
        }
      });

      // Append submenu sections after parent items
      result.push(...submenuSections);

      return result;
    },

    buildNavItem(item) {
      const encodedItem =
        item.menu_item?.toLowerCase().replaceAll(" ", "_") ||
        item.menu?.toLowerCase().replaceAll(" ", "_");

      return {
        _name: "CSidebarNavItem",
        name: item.menu_item || item.menu,
        to: this.getPathForMenu(encodedItem, item.params),
        icon: "cil-settings",
      };
    },
    getItemWithSubMenu(item) {
      let data = [];
      switch (item) {
        case "view/edit_job_board":
          data = [
            {
              _name: "CSidebarNavTitle",
              _children: ["View/Edit Job Board"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Active Jobs",
              to: "/jobs-list/status/active",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Inactive Jobs",
              to: "/jobs-list/status/inactive",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Archive Jobs",
              to: "/jobs-list/status/archive",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Job Templates",
              to: "/list-job-templates",
              icon: "cil-library",
            },
          ];

          if (this.isCustomerAdmin) {
            data.push({
              _name: "CSidebarNavItem",
              name: "Public Job Board",
              to: "/config-public-job-board",
              icon: "cil-library",
            });
          }

          break;
        case "organisation": {
          if (!this.isSuperCustomer) {
            data = [
              { _name: "CSidebarNavTitle", _children: ["Organisation"] },
              {
                _name: "CSidebarNavItem",
                name: "Add Organisation",
                to: "/add-organisation",
                icon: "cil-library",
              },
              {
                _name: "CSidebarNavItem",
                name: this.isEducationalInstitute
                  ? "Organisation List"
                  : "List Organisation",
                to: "/organisation-list",
                icon: "cil-library",
              },
            ];
          } else {
            data = [
              { _name: "CSidebarNavTitle", _children: ["Organisation"] },
              {
                _name: "CSidebarNavItem",
                name: "List Organisation Relations",
                to: "/organisation-relations",
                icon: "cil-library",
              },
              {
                _name: "CSidebarNavItem",
                name: "Non-related Organisations",
                to: "/unrelated-organisation-relations",
                icon: "cil-library",
              },
            ];
          }
          break;
        }
        case "users":
          data = [
            {
              _name: "CSidebarNavTitle",
              _children: ["Users"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Add User",
              to: "/add-contactuser",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "List User",
              to: "/list-contactuser",
              icon: "cil-library",
            },
          ];
          break;
        case "config":
          data = [
            {
              _name: "CSidebarNavTitle",
              _children: ["Config"],
            },

            {
              _name: "CSidebarNavItem",
              name: "Document Library",
              to: "/onboarding-documents",
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Email Templates",
              to: "/email-templates",
              icon: "cil-library",
            },
            // {
            //   _name: "CSidebarNavItem",
            //   name: "Campaign Form",
            //   to: "/campaign-register",
            //   icon: "cil-library",
            // },
          ];
          break;
        case "talent_pool":
          const baseUrl = this.getCandidateListUrlBasedOnRole.replace(
            /(\/full_registration|\/short_registration)$/,
            "",
          );

          data = [
            {
              _name: "CSidebarNavTitle",
              _children: ["Talent Pool"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Full Registered",
              to: `/${baseUrl.replace(/^\/+/, "")}/full_registration`,
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "Short Registered",
              to: `/${baseUrl.replace(/^\/+/, "")}/short_registration`,
              icon: "cil-library",
            },
            {
              _name: "CSidebarNavItem",
              name: "All",
              to: `/${baseUrl.replace(/^\/+/, "")}`,
              icon: "cil-library",
            },
          ];
          break;

        default:
          break;
      }
      return data;
    },
    getPathForMenu(menu, pathParams = "") {
      let path = this.getCandidateListUrlBasedOnRole;
      const isSystemAdmin = this.isSystemAdminFromAccessToken;

      let talent_pool_url = this.getCandidateListUrlBasedOnRole;

      if (menu === "talentfind" || this.isSuperCustomer) {
        talent_pool_url = TFW_CANDIDATE_URL;
        if (this.isSuperCustomer) {
          talent_pool_url = TFW_CANDIDATE_URL.replace("/full_registration", "");
        }
      }
      switch (menu) {
        case "system_dashboard":
          path = "/dashboard";
          break;
        case "dashboard":
          path = isSystemAdmin ? "/dashboard" : "/recruiter-dashboard";
          break;
        case "recruiter_dashboard":
          path = "/recruiter-dashboard";
          break;
        case "add_candidate":
          path = "/add-new-candidate";
          break;
        case "talent_pool":
          path = this.isEducationalInstitute
            ? this.getCandidateListUrlBasedOnRole
            : "/candidate-list/super_customer/full_registration";
          break;
        case "recruitment_status":
          path = "/job-candidates-status?tab=allTab";
          break;
        case "add_customer":
          path = "/add-customer";
          break;
        case "customer_list":
          path = "/customer-list";
          break;
        case "create_job":
          path = "/add-job?step=0";
          break;
        case "job_list":
          path = "/job-list?published=%5B27,28,29%5D";
          break;
        case "allocate_job":
          path = "/job-allocation";
          break;
        case "job_templates":
          path = "/list-job-templates";
          break;
        case "theme_and_logo":
          path = "/theme-and-logo";
          break;
        case "onboarding_docs":
          path = "/onboarding-documents";
          break;
        case "management_report":
          path = "/management-report";
          break;
        case "document_library":
          path = "/onboarding-documents";
          break;
        case "course_list":
          path = "/list-course";
          break;
        case "add_course":
          path = "/add-course";
          break;
        case "list_course":
          path = "/list-course";
          break;
        case "create_course":
          path = "/add-course";
          break;
        case "customer_template":
          path = "/customer_template";
          break;
        case "profile_page":
          path = "/profile-page";
          break;
        case "campaign_form":
          path = "/campaign-register";
          break;
        case "add_partner":
          path = "/add-partner";
          break;
        case "partner_list":
          path = "/partner-list";
          break;
        case "add_profile_page":
          path = "/add-profile-page";
          break;
        case "setup_ai_web_page":
          path = "/setup-ai-web-page";
          break;
        case "organisation_add":
          path = "/add-organisation";
          break;
        case "organisation_list":
          path = "/organisation-list";
          break;
        case "talent_pool":
          path = this.getCandidateListUrlBasedOnRole;
          break;
        case "add_user":
          path = "/add-contactuser";
          break;
        case "list_user":
          path = "/list-contactuser";
          break;
        case "public_job_board":
          path = "/config-public-job-board";
          break;
        case "theme_and_logo":
          path = "/theme-and-logo";
          break;
        case "document_library":
          path = "/onboarding-documents";
          break;
        case "email_config":
          path = "/email-templates";
          break;
        case "active_jobs":
          path = "/jobs-list/status/active";
          break;
        case "inactive_jobs":
          path = "/jobs-list/status/inactive";
          break;
        case "archive_jobs":
          path = "/jobs-list/status/archive";
          break;
        case "full_registered_candidates":
          path = `${this.getCandidateListUrlBasedOnRole}/full_registration`;
          break;
        case "candidates":
          path = this.isEducationalInstitute
            ? this.getCandidateListUrlBasedOnRole
            : "/candidate-list/super_customer/full_registration";
          break;

        case "short_registered_candidates":
          path = `${this.getCandidateListUrlBasedOnRole}/short_registration`;
          break;

        case "add_organisation":
          path = "/add-organisation";
          break;

        case "list_organisation":
          path = "/organisation-list";
          break;
      }
      if (!pathParams) return path;

      const [basePath, queryString] = path.split("?");
      const finalPath = `${basePath}/${pathParams}`;

      const res = queryString ? `${finalPath}?${queryString}` : finalPath;

      return res;
    },
    normalizeKey(key) {
      return key.toLowerCase().replace(/\s+/g, "_");
    },
    convertToSnackCase(str) {
      return str.toLowerCase().replaceAll(" ", "_").replaceAll("/", "_");
    },
  },
  mounted() {
    this.$root.$on("toggle-sidebar", () => {
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
    });
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
